
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/templates",
      function () {
        return require("private-next-pages/customer-studio/templates.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/templates"])
      });
    }
  